import { createReducer, on } from '@ngrx/store';
import { NotificationState, initialNotificationState } from '../states/notification.state';
import * as NotificationActions from '../actions/notification.action';

export const notificationReducer = createReducer(
    initialNotificationState,
    on(NotificationActions.changed, (state, payload) => ({
        ...state,
        ...payload
    }))
);
